import { render, staticRenderFns } from "./LayerWave.vue?vue&type=template&id=73cb9c1f&scoped=true&"
import script from "./LayerWave.vue?vue&type=script&lang=js&"
export * from "./LayerWave.vue?vue&type=script&lang=js&"
import style0 from "./LayerWave.vue?vue&type=style&index=0&id=73cb9c1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cb9c1f",
  null
  
)

export default component.exports